import { css } from '@mui/material/styles';
export const formControlComponentOverrides = {
    MuiFormControl: {
        styleOverrides: {
            root: () => css `
                &:has(.MuiInputBase-hiddenLabel) {
                    .MuiInputLabel-root {
                        display: none;
                    }
                }
            `
        }
    }
};
